var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMatenimiento4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 214,
    height: 214,
    viewBox: "0 0 214 214",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6786",
    "data-name": "Rectangle 6786",
    width: 214,
    height: 214,
    transform: "translate(-12 -12)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_4",
    "data-name": 4,
    transform: "translate(12 12)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8790",
    "data-name": "Group 8790",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22953",
    "data-name": "Path 22953",
    d: "M96.873,191.343a95.672,95.672,0,1,1,95.673-95.672,95.78,95.78,0,0,1-95.673,95.672m0-182.754a87.082,87.082,0,1,0,87.084,87.082A87.223,87.223,0,0,0,96.873,8.589",
    fill: "#002445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22954",
    "data-name": "Path 22954",
    d: "M192.219,31.464a29,29,0,1,1-29-29,29,29,0,0,1,29,29",
    fill: "#008bc9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22955",
    "data-name": "Path 22955",
    d: "M164.479,51.1a10.191,10.191,0,0,1-5.8-1.7,2.392,2.392,0,0,1-1.131-2.211c.051-1.672-.1-3.356-.186-5.031a1.813,1.813,0,0,0-.247-.826,10.266,10.266,0,0,1-1.182-3.788,1.762,1.762,0,0,0-.5-.844c-.5-.51-1.075-.943-1.568-1.457a4.367,4.367,0,0,1-1.078-4.5,16.218,16.218,0,0,1,.587-1.756,16.281,16.281,0,0,0,1.1-5.888,12.6,12.6,0,0,1,.148-1.674,3.722,3.722,0,0,1,3.466-3.424c1.54-.251,3.113-.3,4.665-.495a18.048,18.048,0,0,0,2.665-.517A4.784,4.784,0,0,0,168,15.036a1.647,1.647,0,0,1,2.239-.642c.921.43,1.755,1.046,2.652,1.531a28.3,28.3,0,0,0,2.938,1.452,3.487,3.487,0,0,0,1.416-.011,3.677,3.677,0,0,0,.551-.172c.9-.224,1.326.049,1.45.976.134.994.144,2.016.373,2.987a9.9,9.9,0,0,0,1.019,2.806,6.332,6.332,0,0,1,.527,5.722c-.471,1.283-.962,2.567-1.331,3.882a5.229,5.229,0,0,0-.069,1.954,4.679,4.679,0,0,1-2.749,4.727,19.849,19.849,0,0,1-2.5.435,2.132,2.132,0,0,0-.874.43c-.648.522-1.243,1.1-1.885,1.633a3.191,3.191,0,0,0-1.352,2.963c.092.879,0,1.777.025,2.666a1.026,1.026,0,0,1-.412.887,8.046,8.046,0,0,1-5.54,1.837m-2-20.613c-.2-2.471-.393-4.9-.581-7.321-.064-.807-.518-1.3-1.209-1.266-.731.032-1.1.495-1.078,1.341.076,2.513.146,5.028.242,7.542.018.454-.1.727-.594.828-.285-1.491-.549-2.948-.844-4.4a1.047,1.047,0,0,0-1.227-.8,1,1,0,0,0-.79,1.17c.117.842.27,1.677.38,2.52.224,1.739.465,3.481.634,5.226.179,1.845.263,3.7,1.267,5.354a2.938,2.938,0,0,1,.261.768,19.607,19.607,0,0,1,.31,5.428,1.442,1.442,0,0,0,.825,1.432,8.66,8.66,0,0,0,4.047,1.083,7.275,7.275,0,0,0,4.133-.9.848.848,0,0,0,.473-.843c-.029-.812.016-1.625-.013-2.437A4.111,4.111,0,0,1,170,42.085c.389-.4.862-.721,1.249-1.122.76-.791,1.537-1.573,2.218-2.43,1.12-1.4,2.159-2.872,3.252-4.294.533-.694.316-1.554-.553-1.68a3,3,0,0,0-1.659.282,24.492,24.492,0,0,0-2.559,1.58c-.714.475-1.259.391-1.57-.405a4.273,4.273,0,0,1-.346-1.851c.239-2.513.563-5.024.885-7.534.116-.916-.2-1.539-.962-1.7A1.327,1.327,0,0,0,168.4,24.1c-.407,2.157-.917,4.294-1.387,6.443-.508.077-.756-.058-.752-.594.031-2.725.041-5.457.06-8.186a1.249,1.249,0,1,0-2.488-.162q-.259,4.023-.479,8.049c-.043.777-.02.777-.87.836",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22956",
    "data-name": "Path 22956",
    d: "M144.822,17.126c3.2-.31,4.82-2.133,5.16-5.293.33,3.188,2,5.008,5.253,5.311-3.25.318-4.938,2.116-5.22,5.309-.581-3.23-1.554-4.716-5.193-5.327",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22957",
    "data-name": "Path 22957",
    d: "M152.066,28.759a3.276,3.276,0,0,0-3.015,3.144A3.293,3.293,0,0,0,146,28.764a3.269,3.269,0,0,0,3.046-3.2,3.283,3.283,0,0,0,3.021,3.2",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22958",
    "data-name": "Path 22958",
    d: "M162.482,30.486c.85-.059.827-.059.87-.836q.224-4.029.479-8.049a1.249,1.249,0,1,1,2.488.162c-.019,2.729-.029,5.461-.06,8.186,0,.536.244.671.752.594.47-2.149.98-4.286,1.387-6.443a1.327,1.327,0,0,1,1.559-1.167c.766.159,1.078.782.962,1.7-.322,2.51-.646,5.021-.885,7.534a4.273,4.273,0,0,0,.346,1.851c.311.8.856.88,1.57.405a24.492,24.492,0,0,1,2.559-1.58,3,3,0,0,1,1.659-.282c.869.126,1.086.986.553,1.68-1.093,1.422-2.132,2.89-3.252,4.294-.681.857-1.458,1.639-2.218,2.43-.387.4-.86.722-1.249,1.122a4.111,4.111,0,0,0-1.284,3.124c.029.812-.016,1.625.013,2.437a.848.848,0,0,1-.473.843,7.275,7.275,0,0,1-4.133.9,8.66,8.66,0,0,1-4.047-1.083,1.442,1.442,0,0,1-.825-1.432,19.607,19.607,0,0,0-.31-5.428,2.938,2.938,0,0,0-.261-.768c-1-1.649-1.088-3.509-1.267-5.354-.169-1.745-.41-3.487-.634-5.226-.11-.843-.263-1.678-.38-2.52a1,1,0,0,1,.79-1.17,1.047,1.047,0,0,1,1.227.8c.295,1.453.559,2.91.844,4.4.491-.1.612-.374.594-.828-.1-2.514-.166-5.029-.242-7.542-.027-.846.347-1.309,1.078-1.341.691-.03,1.145.459,1.209,1.266.188,2.425.384,4.85.581,7.321",
    fill: "#009cdd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22959",
    "data-name": "Path 22959",
    d: "M127.462,91.107c-1.506-.443-3.124,0-4.785,0H74.218a17.064,17.064,0,0,0-2.075.14l-14.411-.14v29.142h64.945c8.7,0,15.821-6.558,15.821-14.572V91.289Z",
    fill: "#464545"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6748",
    "data-name": "Rectangle 6748",
    width: 80.767,
    height: 7.494,
    transform: "translate(57.731 83.613)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22960",
    "data-name": "Path 22960",
    d: "M130.754,65.794H65.476a7.431,7.431,0,0,0-7.41,7.411V83.613h80.1V73.205a7.433,7.433,0,0,0-7.41-7.411",
    fill: "#464545"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6749",
    "data-name": "Rectangle 6749",
    width: 44.461,
    height: 7.494,
    transform: "translate(93.58 83.613)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22961",
    "data-name": "Path 22961",
    d: "M138.744,91.81H92.877v-8.9h45.867ZM94.283,90.4h43.055V84.317H94.283Z",
    fill: "#464545"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22962",
    "data-name": "Path 22962",
    d: "M94.669,91.742H57.1V82.976H94.669Zm-36.3-1.272H93.4V84.247H58.367Z",
    fill: "#464545"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22963",
    "data-name": "Path 22963",
    d: "M97.215,89.469H96.4a.4.4,0,0,1-.4-.4V85.645a.4.4,0,0,1,.4-.4h.818a.4.4,0,0,1,.4.4v3.428a.4.4,0,0,1-.4.4",
    fill: "#4d5a5f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22964",
    "data-name": "Path 22964",
    d: "M100.148,89.469h-.819a.4.4,0,0,1-.394-.4V85.645a.4.4,0,0,1,.394-.4h.819a.4.4,0,0,1,.4.4v3.428a.4.4,0,0,1-.4.4",
    fill: "#4d5a5f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22965",
    "data-name": "Path 22965",
    d: "M103.084,89.469h-.819a.4.4,0,0,1-.394-.4V85.645a.4.4,0,0,1,.394-.4h.819a.4.4,0,0,1,.4.4v3.428a.4.4,0,0,1-.4.4",
    fill: "#4d5a5f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6750",
    "data-name": "Rectangle 6750",
    width: 58.535,
    height: 26.477,
    transform: "translate(57.732 120.249)",
    fill: "#464545"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22966",
    "data-name": "Path 22966",
    d: "M116.442,146.9H57.555V120.073h58.887Zm-58.535-.352h58.184V120.425H57.907Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6751",
    "data-name": "Rectangle 6751",
    width: 82.764,
    height: 0.704,
    transform: "translate(56.467 67.275)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6752",
    "data-name": "Rectangle 6752",
    width: 82.764,
    height: 0.704,
    transform: "translate(56.467 69.956)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6753",
    "data-name": "Rectangle 6753",
    width: 82.764,
    height: 0.704,
    transform: "translate(56.467 72.636)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6754",
    "data-name": "Rectangle 6754",
    width: 82.764,
    height: 0.704,
    transform: "translate(56.467 75.318)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6755",
    "data-name": "Rectangle 6755",
    width: 82.764,
    height: 0.704,
    transform: "translate(56.467 77.998)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6756",
    "data-name": "Rectangle 6756",
    width: 82.764,
    height: 0.704,
    transform: "translate(56.467 80.68)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6757",
    "data-name": "Rectangle 6757",
    width: 0.704,
    height: 19.65,
    transform: "translate(66.206 63.963)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6758",
    "data-name": "Rectangle 6758",
    width: 0.705,
    height: 19.65,
    transform: "translate(68.954 63.963)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6759",
    "data-name": "Rectangle 6759",
    width: 0.704,
    height: 19.65,
    transform: "translate(71.701 63.963)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6760",
    "data-name": "Rectangle 6760",
    width: 0.704,
    height: 19.65,
    transform: "translate(60.711 63.963)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6761",
    "data-name": "Rectangle 6761",
    width: 0.705,
    height: 19.65,
    transform: "translate(63.458 63.963)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6762",
    "data-name": "Rectangle 6762",
    width: 0.705,
    height: 19.65,
    transform: "translate(79.943 63.963)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6763",
    "data-name": "Rectangle 6763",
    width: 0.704,
    height: 19.65,
    transform: "translate(82.693 63.963)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6764",
    "data-name": "Rectangle 6764",
    width: 0.704,
    height: 19.65,
    transform: "translate(101.027 63.963)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6765",
    "data-name": "Rectangle 6765",
    width: 0.705,
    height: 19.65,
    transform: "translate(74.448 63.963)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6766",
    "data-name": "Rectangle 6766",
    width: 0.704,
    height: 19.65,
    transform: "translate(77.196 63.963)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6767",
    "data-name": "Rectangle 6767",
    width: 0.705,
    height: 18.45,
    transform: "translate(108.707 65.163)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6768",
    "data-name": "Rectangle 6768",
    width: 0.704,
    height: 18.45,
    transform: "translate(111.455 65.163)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6769",
    "data-name": "Rectangle 6769",
    width: 0.704,
    height: 18.45,
    transform: "translate(114.202 65.163)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6770",
    "data-name": "Rectangle 6770",
    width: 0.705,
    height: 19.65,
    transform: "translate(103.212 63.963)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6771",
    "data-name": "Rectangle 6771",
    width: 0.704,
    height: 18.45,
    transform: "translate(105.958 65.163)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6772",
    "data-name": "Rectangle 6772",
    width: 0.704,
    height: 19.65,
    transform: "translate(122.494 63.963)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6773",
    "data-name": "Rectangle 6773",
    width: 0.704,
    height: 19.65,
    transform: "translate(125.24 63.963)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6774",
    "data-name": "Rectangle 6774",
    width: 0.704,
    height: 19.65,
    transform: "translate(127.989 63.963)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6775",
    "data-name": "Rectangle 6775",
    width: 0.704,
    height: 18.45,
    transform: "translate(116.997 65.163)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6776",
    "data-name": "Rectangle 6776",
    width: 0.704,
    height: 18.45,
    transform: "translate(119.747 65.163)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6777",
    "data-name": "Rectangle 6777",
    width: 0.595,
    height: 16.586,
    transform: "translate(130.416 58.185)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6778",
    "data-name": "Rectangle 6778",
    width: 0.704,
    height: 19.65,
    transform: "translate(85.188 63.963)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6779",
    "data-name": "Rectangle 6779",
    width: 0.704,
    height: 19.65,
    transform: "translate(87.934 63.963)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6780",
    "data-name": "Rectangle 6780",
    width: 0.704,
    height: 19.65,
    transform: "translate(130.938 63.963)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6781",
    "data-name": "Rectangle 6781",
    width: 0.705,
    height: 19.65,
    transform: "translate(133.686 63.963)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6782",
    "data-name": "Rectangle 6782",
    width: 0.704,
    height: 19.65,
    transform: "translate(96.258 63.963)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6783",
    "data-name": "Rectangle 6783",
    width: 0.704,
    height: 19.65,
    transform: "translate(98.842 63.963)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6784",
    "data-name": "Rectangle 6784",
    width: 0.704,
    height: 19.65,
    transform: "translate(90.765 63.963)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6785",
    "data-name": "Rectangle 6785",
    width: 0.704,
    height: 19.65,
    transform: "translate(93.514 63.963)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22967",
    "data-name": "Path 22967",
    d: "M138.6,84.316H57.1V72.835a8.256,8.256,0,0,1,8.114-8.375h65.276a8.258,8.258,0,0,1,8.116,8.375ZM58.5,82.909H137.2V72.835a6.849,6.849,0,0,0-6.708-6.968H65.211A6.849,6.849,0,0,0,58.5,72.835Z",
    fill: "#464545"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMatenimiento4);
export default __webpack_public_path__ + "static/media/matenimiento_4.2d9bf89eefb5805dca53b2b37bb879db.svg";
export { ForwardRef as ReactComponent };